import {
  Box,
  DialogTitle,
  DialogContent,
  Card,
  CardContent,
  DialogActions,
} from '@mui/material';
import React from 'react';
import { isEmpty } from 'lodash';
import MyPaperComponent from '../../common/components/MyPaperComponent';
import { MyButton } from '../../common/components';
import AllReferralNotes from '../../referral/notes/AllReferralNotes';
import CustomDialog from '../../common/components/CustomDialog';

export default function DialogReferralNotes({ referralUuid, openNotes, handleClose, isExternal = false }) {
  return (
    <CustomDialog
      open={openNotes}
      onClose={handleClose}
      PaperComponent={MyPaperComponent}
      aria-labelledby="draggable-dialog-title"
      style={{ minWidth: '800px' }}
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Referral Notes
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          <Card style={{ padding: '0' }}>
            <CardContent>
              {!isEmpty(referralUuid) && <AllReferralNotes uuid={referralUuid} isExternal={isExternal} />}
            </CardContent>
          </Card>
        </Box>
      </DialogContent>
      <DialogActions>
        <MyButton autoFocus onClick={handleClose} fullWidth={false}>
          Close
        </MyButton>
      </DialogActions>
    </CustomDialog>
  );
}
